module.exports = __webpack_public_path__ + "img/asset7.a694ac5e.svg";